import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'
import axios from 'axios'
import styled from 'styled-components'

import Filter from './filter-mobile'
import Tile from './mosaic-tile-mobile'
import Api, { getAllProjects } from './api'
import Axios from 'axios'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  background-color: white;
`
const TilesWrapper = styled.div`
  margin-top: 19vh;
  display: flex;
  flex-wrap: wrap;
  width: 100vw;
  overflow: hidden;
`
const NavigationDimmer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  background-color: gray;
  width: 100vw;
  height: 15vh;
  z-index: 2;
`

const LoadingIndicator = styled.div`
  width: 100px;
  height: 100px;
  background-color: red;
`

class Mosaic extends Component {
  constructor(props) {
    super(props)
    this._projects = undefined
    this.state = {
      isLoading: true,
      filter: 'all',
      projects: [],
      language: '',
    }
  }

  componentDidMount() {
    //present the indicator
    this.setState({ isLoading: true })

    getAllProjects(location.search).then(projects => {
      this._projects = projects
      this.setState({
        projects: this._projects,
        language: location.search || '',
        isLoading: false,
      })
    })
  }

  onFilterBy = criteria => {
    if (criteria === 'all') {
      this.setState({ projects: this._projects })
    } else {
      const filtered = this._projects.filter(project => {
        let found = false
        if (project.categories instanceof Array) {
          found =
            project.categories.filter(e => e.trim() === criteria).length > 0
        } else {
          found = project.categories === criteria
        }
        return found
      })
      this.setState({ projects: filtered })
    }
  }

  render() {
    const { projects, isLoading } = this.state
    return (
      <Wrapper>
        {!isLoading && (
          <Fragment>
            <NavigationDimmer />
            <Filter filterBy={this.onFilterBy} />
            <TilesWrapper>
              {projects.map((project, index) => {
                // for each project
                let image = undefined
                // filter the cover image
                let filtered = project.files.filter(
                  file => file.url.indexOf(project.cover) !== -1
                )
                //if we've got a cover
                //use it
                if (filtered.length) {
                  const cover = filtered.pop()
                  image = {
                    url: cover.url,
                    width: cover.width,
                    height: cover.height,
                  }
                }
                // and return the tile with it
                return (
                  <Tile
                    key={index}
                    title={project.title}
                    subtitle={project.categories}
                    image={image}
                    url={`/projeto/${project.uid}${this.state.language}`}
                  />
                )
              })}
            </TilesWrapper>
          </Fragment>
        )}
      </Wrapper>
    )
  }
}

export default Mosaic



// WEBPACK FOOTER //
// ./src/components/mosaic-mobile.js